var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasswordEye = function SvgPasswordEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.819 12.323c.078 2.739-5.133 7.323-11.906 7.323S-.227 14.586.007 12.323C.242 10.061 5.14 5 11.913 5s11.827 4.584 11.905 7.323Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.152 13.018c.02-.158-.134-.277-.288-.238a3.67 3.67 0 0 1-4.1-5.343c.078-.14.003-.32-.155-.34a5.27 5.27 0 1 0 4.543 5.92Z"
  })));
};
export default SvgPasswordEye;